import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/* ------------------------------ helpers ------------------------------ */
const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

const pickData = (res) => res?.data ?? res?.entry ?? res;

const tryParseJson = (text) => {
  if (typeof text !== "string") return text;
  const t = text.trim();
  if (!t) return null;

  try {
    return JSON.parse(t);
  } catch {
    // if server sent HTML or plain text
    return { raw: t };
  }
};

/**
 * ✅ Custom baseQuery
 * - Always reads response as TEXT
 * - then tries JSON.parse
 * - prevents "Unexpected token < in JSON" crashes (HTML error case)
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  credentials: "include",
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    return headers;
  },
  responseHandler: async (response) => {
    const text = await response.text();
    return text;
  },
});

const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  // ✅ error case
  if (result?.error) {
    const data = tryParseJson(result.error.data);
    return {
      ...result,
      error: {
        ...result.error,
        data,
      },
    };
  }

  // ✅ success case
  if (typeof result?.data === "string") {
    const parsed = tryParseJson(result.data);
    return { ...result, data: parsed };
  }

  return result;
};

/* ------------------------------------------------------------------- */

export const securityPinApi = createApi({
  reducerPath: "securityPinApi",
  baseQuery,
  tagTypes: ["PIN_STATUS"],
  endpoints: (builder) => ({
    /* -------------------------- GENERATE PIN -------------------------- */
    // POST /api/security/pin/generate
    generateSecurityPin: builder.mutation({
      query: () => ({
        url: "/security/pin/generate",
        method: "POST",
      }),
      invalidatesTags: ["PIN_STATUS"],
    }),

    /* --------------------------- VERIFY PIN --------------------------- */
    // POST /api/security/pin/verify  body: { pin }
    verifySecurityPin: builder.mutation({
      query: ({ pin }) => ({
        url: "/security/pin/verify",
        method: "POST",
        body: { pin },
        headers: { "Content-Type": "application/json" },
      }),
    }),

    /* -------------------------- (OPTIONAL) STATUS -------------------------- */
    // Agar backend me future me GET /security/pin/status add karega, toh ye ready hai:
    // getPinStatus: builder.query({
    //   query: () => ({ url: "/security/pin/status", method: "GET" }),
    //   providesTags: ["PIN_STATUS"],
    //   keepUnusedDataFor: 30,
    // }),
  }),
});

/* ----------------------------- hooks ----------------------------- */
export const {
  useGenerateSecurityPinMutation,
  useVerifySecurityPinMutation,
  // useGetPinStatusQuery,
} = securityPinApi;

export default securityPinApi;
